import type {CustomActions} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import
import {mapValues, pickBy} from 'lodash'
import {BaseActionsBuilder} from './BaseActionsBuilder'
import type {ManifestFeatureGfppDesktopConfig} from '@wix/document-services-types'
import type {ManifestActionValue} from './types'
import {ActionsHelpers} from './ActionsHelpers'
import {ActionExecutionBuilder} from './ActionExecutionBuilder'

export class CustomActionsBuilder extends BaseActionsBuilder<CustomActions> {
    private readonly ActionIds = {
        mainAction1: 'design',
        mainAction2: 'design'
    }

    private isActionNameExistInActionIds = (actionName: string): actionName is keyof typeof this.ActionIds => {
        return actionName in this.ActionIds
    }

    protected pickSupportedActions = (data: ManifestFeatureGfppDesktopConfig): Record<string, ManifestActionValue> => {
        const {mainActions, supportedIconButtons} = ActionsHelpers.prepareCustomActionValues(data)

        const customActions = data.iconButtons
            ? pickBy(data.iconButtons, (value, key) => {
                  const isSupported = supportedIconButtons.has(key)
                  const isActionIdExist = value && 'actionId' in value && !!value.actionId
                  return isSupported && isActionIdExist
              })
            : {}
        return {...mainActions, ...customActions}
    }

    private getResolvedAction = (action: ManifestActionValue, key: string): ManifestActionValue => {
        return action?.behavior?.startsWith('DEFAULT') && this.isActionNameExistInActionIds(key)
            ? {actionId: this.ActionIds[key], behavior: 'CUSTOM_ACTION'}
            : action
    }

    protected transformToBuilderActions(data: Record<string, ManifestActionValue>) {
        return mapValues(data, (action, key) => new ActionExecutionBuilder().build(this.getResolvedAction(action, key)))
    }
}
